import {Component, OnInit} from '@angular/core';
import {TooltipPosition} from "./tooltip-position";

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {

  tooltip: string = '';
  left: number = 0;
  top: number = 0;
  position: TooltipPosition = TooltipPosition.RIGHT;
  zIndex: number = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

}
